import { render, staticRenderFns } from "./ManageWorkSpace.vue?vue&type=template&id=2914b6ca&scoped=true&"
import script from "./ManageWorkSpace.vue?vue&type=script&lang=js&"
export * from "./ManageWorkSpace.vue?vue&type=script&lang=js&"
import style0 from "./ManageWorkSpace.vue?vue&type=style&index=0&id=2914b6ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2914b6ca",
  null
  
)

export default component.exports